export default "<div #chart id=\"scatterChart\"></div>"